module.exports = __webpack_public_path__ + "static/work58-c6012dcacac3804db33277ca0961483e.jpg";